import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import mainReducer from '../reducers'

const logger = store => next => action => {
  console.log('dispatching', action);
  let result = next(action);
  console.log('next state', store.getState());
  return result;
}

var middleware = [thunk];

var enableLogging = false;
if(enableLogging) {
    middleware.push(logger);
}

let composeEnhancers = compose;
if (process.env.NODE_ENV !== 'production') {
  composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
}

let store = createStore(mainReducer, {}, composeEnhancers(applyMiddleware(...middleware)));
export default store;
